
import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { isNumber, isBoolean } from 'lodash'
import { withStyles } from '@material-ui/core'
import { MAXIMUM_CHARACTERS_PER_FACTOR, MAXIMUM_FACTORS_PER_OPTION } from '../../../constants'
import withWidth, { isWidthDown } from '@material-ui/core/withWidth'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import * as actions from '../../../actionTypes'
import FactorTextField from './FactorTextField'
import Factor from './Factor/Factor'
import FormHeader from '../FormHeader'
import { FactorContinueModal, FactorDeleteModal, FactorSkipModal } from './Modals/'


const styles = {
  flatTopButton: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0
  },
  fullWidth: {width: '100%'}
}

const theme = theme => ({
  decision: {
    color: theme.typography.label.color
  }
})

const ordinals = ['First', 'Second', 'Third', 'Fourth', 'Fifth']

class EnterFactorContainer extends Component {
  constructor(props) {
    super(props)
    let whichOptionArray = 'factorsOption' + props.routeData.factorsOption

    this.state = {
      addFactorEnabled: false,
      factorsAdded: 0,
      newFactor: '',
      toDeleteIndex: null,
      whichOption: whichOptionArray,
      focused: false,
      isSkipModalOpened: false,
      isDeleteModalOpened: false,
      isContinueModalOpened: false,
      disregard: false
    }
    props.navigator.resetNavigationVisibilityAndLabel()
    this.newFactorInputRef = React.createRef()
    this.props.navigator.amendNavigation({ forward: this.checkUnsaved })
  }

  componentDidMount() {
    const {whichOption} = this.state
    this.focusNewFactorInput()
    // @TODO - flexParent is breaking the positioning of caseId. This was also initially done
    // to fix flex issues on Safari, and with newer changes, does not even appear
    // to work anymore. Will have to revisit this.
    // this.flexParent()
    if(Array.isArray(this.props[whichOption])) {
      this.setState({factorsAdded: this.props[whichOption].length})
    }
    if(!this.state.factorsAdded.length) {
      this.props.navigator.disableForward()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {navigator} = this.props
    const {factorsAdded, whichOption} = this.state
    if(prevProps[whichOption] !== this.props[whichOption]) {
      this.setState({factorsAdded: this.props[whichOption].length})
    }
    if(prevState.factorsAdded !== factorsAdded && isNumber(factorsAdded)) {
      if(factorsAdded > 0) {
        if(factorsAdded < MAXIMUM_FACTORS_PER_OPTION) {
          this.focusNewFactorInput()
        }
        navigator.enableForward()
      } else {
        navigator.disableForward()
      }
    }
  }

  /**
   * Not a big fan of this, but am current unable to achieve the desired affect with a HOC.
   * Addresses a <Grid> placement issue visible in safari - specifically in regards to the placement
   * of the `Skip This Step` Button. Since the node we need to access is dynamically inserted,
   * we cannot use css directly.
   */
  flexParent() {
    const pageContainer = document.getElementsByClassName('counseling-session-page-container')
    if(pageContainer && pageContainer[0]) {
      pageContainer[0].parentNode.style.display = 'flex'
    }
  }

  focusNewFactorInput() {
    if (!this.props.isCounselingSessionDisabled) {
      this.newFactorInputRef.focus()
    }
  }

  getDeleteFactorSnippet() {
    const {toDeleteIndex, whichOption} = this.state
    const factor = this.props[whichOption][toDeleteIndex]
    // u2026 is unicode for horizontal ellipsis
    // 50 is an arbitrary cap
    const factorSnippet = factor.length > 50 ? `${factor.substring(0, 50)} \u2026` : factor
    return factorSnippet
  }

  handleTextFieldChange = (event) => {
    if (event.target.value.length >= 1) {
      this.setState({newFactor: event.target.value, addFactorEnabled: true})
    } else {
      this.setState({newFactor: '', addFactorEnabled: false})
    }
  }

  onClickAddButton = (forward) => {
    this.props.addFactor(this.state.whichOption, this.state.newFactor)
    this.setState({
      addFactorEnabled: false,
      newFactor: '',
      factorsAdded: this.state.factorsAdded + 1
    }, () => isBoolean(forward) && forward ? this.props.navigator.forward() : null)
    this.props.navigator.enableForward()
  }

  onClickRemoveButton = (navigator, factorIndex) => {
    this.setState({
      isDeleteModalOpened: true,
      toDeleteIndex: factorIndex
    })

    this.stopEditing(navigator)
  }

  removeFactor = () => {
    const { factorsAdded, toDeleteIndex, whichOption } = this.state
    const totalFactorsAdded = factorsAdded - 1
    this.props.removeFactor(whichOption, toDeleteIndex)
    if(totalFactorsAdded === 0) this.props.navigator.disableForward()
    this.setState({
      isDeleteModalOpened: false,
      factorsAdded: totalFactorsAdded,
      toDeleteIndex: null
    })
  }

  /**
   * `Skip this step` should only display under certain conditions.
   * Hidden under the following conditions
   *  - Session is in read only mode
   *  - If factors have been added for the option
   *  - If viewing option2 and no factors were given for option1
   * @returns {boolean} true if `Skip this Step` should be visible, false otherwise.
   */
  shouldShowSkipStep() {
    const {isCounselingSessionDisabled, factorsOption1} = this.props
    const {factorsAdded, whichOption} = this.state
    return !(isCounselingSessionDisabled || factorsAdded) &&
      !(whichOption === 'factorsOption2' && !factorsOption1.length)
  }

  skipThisStep = () => {
    this.props.skipThisStep(this.state.whichOption)
    this.props.navigator.forward()
  }

  updateFactor = (navigator, whichOption) => {
    this.props.updateFactor(whichOption)
    navigator && this.resetNavigation(navigator)
  }

  saveFactorChanges = (navigator, updatedFactor, whichOption, index) => {
    this.updateFactor(navigator, whichOption)
  }

  startEditing = (navigator, index, factor) => {
    this.props.beginEditingFactor(index, factor)
    navigator.disableForward()
    navigator.disableBack()
  }

  stopEditing = navigator => {
    this.props.endEditingFactor()
    this.resetNavigation(navigator)
  }

  resetNavigation = navigator => {
    navigator.enableForward()
    navigator.enableBack()
  }

  checkUnsaved = () => {
    if (this.hasActiveFactorInput() && !this.state.disregard) { // Text in input throw continue modal
      this.setState({ isContinueModalOpened: true })
      return false
    } else { // Continue to next page
      return true
    }
  }

  hasActiveFactorInput = () => (
    this.state.addFactorEnabled && this.state.newFactor.trim().length > 0
  )

  disregardAndContinue = () => {
    this.setState({
      disregard: true,
      isContinueModalOpened: false
    }, () => this.props.navigator.forward())
  }

  handleKeyDown = (e, value, callback) => {
    if (e.keyCode === 13) { // Enter Key
      if (!e.shiftKey) { // Enter + Non Shift
        return value.trim().length ? callback() : e.preventDefault()
      }
    }
  }

  render() {
    const {
      isCounselingSessionDisabled,
      routeData: {factorsOption: factorOptionStep},
      t,
      navigator,
      editingFactorIndex,
      updateEditedFactor,
      updatedFactor,
      width
    } = this.props
    const { factorsAdded, newFactor, whichOption, saveFactor, focused } = this.state
    const showFactorTextField = !isCounselingSessionDisabled && factorsAdded < MAXIMUM_FACTORS_PER_OPTION
    const showSkipThisStep = this.shouldShowSkipStep()
    const factorOptionIndex = factorOptionStep === '1' ? 0 : 1

    return (
      <Fragment>
        <Grid container className="counseling-session-page-container">
          <Grid container justify="center" alignContent="flex-start" spacing={8}>
            <FormHeader
              description={t('Enter Factors', {OPTIONNUM: factorOptionStep, OPTIONTEXT: this.props.decisionNames[factorOptionIndex],OPTIONNUM2: Math.abs(factorOptionStep-3), OPTIONTEXT2: this.props.decisionNames[Math.abs(factorOptionIndex-1)]})}
              stepNumber={t(`Step ${navigator.getStepNumber()}`)}
            />
            <Grid item xs={10}>
              {this.props[whichOption] && this.props[whichOption].map((factor, index) => (
                <Factor
                  key={index}
                  editing={editingFactorIndex === index}
                  index={index}
                  factor={factor}
                  disabled={!!isCounselingSessionDisabled}
                  onEditStart={() => this.startEditing(navigator, index, factor)}
                  onEditCancel={() => this.stopEditing(navigator)}
                  onDone={() => this.updateFactor(navigator, whichOption)}
                  onRemove={() => this.onClickRemoveButton(navigator, index)}
                  onChange={updatedFactor => updateEditedFactor(updatedFactor)}
                  buttonsDisabled={editingFactorIndex !== null}
                  updatedFactor={updatedFactor}
                  saveChanges={saveFactor !== index ? false : updatedFactor => this.saveFactorChanges(navigator, updatedFactor, whichOption, index)}
                  onKeyDown={this.handleKeyDown}
                />
              ))}
            </Grid>
            <Grid
              item
              style={{paddingBottom: 0, marginTop: 25}}
              xs={10}
            >
              {showFactorTextField && (
                <FactorTextField
                  inputProps={{maxLength: MAXIMUM_CHARACTERS_PER_FACTOR}}
                  inputRef={el => this.newFactorInputRef = el}
                  label={
                    focused ?
                      t('Characters Remaining', {CHARNUM: MAXIMUM_CHARACTERS_PER_FACTOR - newFactor.length}) : ''
                  }
                  multiline={true}
                  onTextFieldChange={this.handleTextFieldChange}
                  placeholder={t(`Enter ${ordinals[factorsAdded]} Factor`)}
                  style={styles.fullWidth}
                  value={newFactor}
                  onFocus={() => this.setState({focused: true})}
                  onBlur={() => this.setState({focused: false})}
                  onKeyDown={e => this.handleKeyDown(e, newFactor, this.onClickAddButton)}
                />
              )}
            </Grid>
            <Grid
              container
              item
              justify="flex-end"
              style={{paddingTop: 0}}
              xs={10}
            >
              {this.state.addFactorEnabled && <Button
                disabled={!newFactor.trim().length}
                variant='contained'
                color="secondary"
                onClick={this.onClickAddButton}
                style={styles.flatTopButton}
              >
                {t('Save')}
              </Button>}
            </Grid>
          </Grid>
          <Grid
            alignItems={isWidthDown('xs', width) ? 'flex-end' : 'flex-start'}
            container
            item
            justify="center"
            spacing={8}
            style={{marginBottom: 25}}
            xs={12}
          >
            <Grid item xs="auto">
              {showSkipThisStep && (
                <Grid container>
                  <Grid item xs>
                    <Button
                      color="primary"
                      onClick={() => this.setState({ isSkipModalOpened: true })}
                      style={{marginTop: 15}}
                    >
                      {t('Skip This Step')}
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
        {this.renderDeleteFactorModal()}
        {this.renderContinueModal()}
        {this.renderSkipModal()}
      </Fragment>
    )
  }

  renderContinueModal() {
    return (
      <FactorContinueModal
        open={this.state.isContinueModalOpened}
        dismissFn={() => this.setState({ isContinueModalOpened: false })}
        disregardFn={this.disregardAndContinue}
        saveFn={() => this.onClickAddButton(true)}
      />
    )
  }

  renderDeleteFactorModal() {
    return (
      <FactorDeleteModal
        open={this.state.isDeleteModalOpened}
        dismissFn={() => this.setState({ isDeleteModalOpened: false })}
        deleteFn={this.removeFactor}
      />
    )
  }

  renderSkipModal() {
    return (
      <FactorSkipModal
        open={this.state.isSkipModalOpened}
        dismissFn={() => this.setState({ isSkipModalOpened: false })}
        skipFn={this.skipThisStep}
        routeData={this.props.routeData}
      />
    )
  }
}

const mapStateToProps = state => ({
  decisionNames: state.counselingSession.counselingSessionData.options,
  editingFactorIndex: state.counselingSession.editingFactorIndex,
  factorsOption1: state.counselingSession.counselingSessionData.factorsOption1,
  factorsOption2: state.counselingSession.counselingSessionData.factorsOption2,
  stepNumberToDisplay: state.counselingSession.stepNumberToDisplay,
  updatedFactor: state.counselingSession.updatedFactor
})

const mapDispatchToProps = dispatch => ({
  addFactor(whichOption, factorString) {
    this.resetTop3AffectCompareArrays()
    this.resetFinalWeight()
    const action = {type: actions.ADD_FACTOR, payload: {whichOption, factorString}}
    dispatch(action)
  },
  removeFactor(whichOption, factorIndex) {
    this.resetTop3AffectCompareArrays()
    this.resetFinalWeight()
    const action = {type: actions.REMOVE_FACTOR, payload: {whichOption, factorIndex}}
    dispatch(action)
  },
  resetFinalWeight() {
    const action = {type: actions.RESET_FINAL_WEIGHT}
    dispatch(action)
  },
  resetTop3AffectCompareArrays() {
    const action = {type: actions.RESET_TOP3_AFFECT_COMPARE_ARRAYS}
    dispatch(action)
  },
  skipThisStep(whichOption) {
    this.resetTop3AffectCompareArrays()
    const action = {type: actions.SKIP_ENTERING_FACTORS_FOR_OPTION, payload: {whichOption}}
    dispatch(action)
  },
  beginEditingFactor(index, updatedFactor) {
    const action = {type: actions.BEGIN_EDITING_FACTOR, payload: {index, updatedFactor}}
    dispatch(action)
  },
  updateEditedFactor(updatedFactor) {
    const action = {type: actions.EDITED_FACTOR_CHANGED, payload: updatedFactor}
    dispatch(action)
  },
  updateFactor(whichOptionUpdate) {
    this.resetTop3AffectCompareArrays()
    const action = {type: actions.UPDATE_FACTOR, payload: whichOptionUpdate}
    dispatch(action)
  },
  endEditingFactor() {
    dispatch({type: actions.END_EDITING_FACTOR})
  }
})

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  withWidth(),
  withStyles(theme),
)(EnterFactorContainer)



// WEBPACK FOOTER //
// ./src/components/counseling-session/enter-factors/EnterFactorsContainer.js